/** Shared intelligence context types — used by Intelligence page and AI analysis. */

export const CONTEXT_TYPES = [
  { id: 'butchers', label: 'Butchers', description: 'Monitor meat storage temperatures to ensure food safety compliance and prevent spoilage.', icon: '🥩', tempRange: '-18°C to 4°C', critical: true },
  { id: 'cold_chain', label: 'Cold Chain Logistics', description: 'Track temperature and humidity throughout the entire supply chain.', icon: '🚛', tempRange: '2°C to 8°C', critical: true },
  { id: 'pharmaceuticals', label: 'Pharmaceuticals', description: 'Critical monitoring for medication storage. Ensure compliance with strict temperature requirements.', icon: '💊', tempRange: '2°C to 8°C', critical: true },
  { id: 'office', label: 'Office Buildings', description: 'Monitor HVAC systems and environmental conditions for comfortable workspaces.', icon: '🏢', tempRange: '20°C to 24°C', critical: false },
  { id: 'daycare', label: 'Day Care Centres', description: 'Ensure safe food storage temperatures for children. Monitor room conditions for safety.', icon: '👶', tempRange: '2°C to 8°C', critical: true },
  { id: 'home_fridge', label: 'Home Fridges', description: 'Keep your family safe by monitoring refrigerator and freezer temperatures.', icon: '🏠', tempRange: '0°C to 5°C', critical: false },
  { id: 'cooling_gazebos', label: 'Cooling Gazebos', description: 'Perfect for trips and outdoor events. Monitor portable cooling units.', icon: '⛺', tempRange: '0°C to 10°C', critical: false },
  { id: 'food_safety', label: 'Food Safety', description: 'Comprehensive monitoring for restaurants and food service. Ensure HACCP compliance.', icon: '🍽️', tempRange: '-18°C to 8°C', critical: true },
  { id: 'fresh_produce', label: 'Fresh Produce', description: 'Monitor temperature and humidity for fresh fruits and vegetables.', icon: '🥬', tempRange: '1°C to 12°C', critical: true },
  { id: 'custom', label: 'Custom', description: 'Define your own monitoring context with custom parameters.', icon: '⚙️', tempRange: 'Custom', critical: false },
];

export function getContextType(contextTypeId) {
  return CONTEXT_TYPES.find((c) => c.id === contextTypeId) || null;
}

export function buildContextMeta(contextRow) {
  if (!contextRow?.context_type) return null;
  const type = getContextType(contextRow.context_type);
  if (!type) return null;
  return {
    contextTypeId: type.id,
    label: type.label,
    icon: type.icon,
    description: type.description,
    tempRange: type.tempRange,
    critical: type.critical,
    customNotes: contextRow.custom_notes || '',
  };
}
